// These hooks are used for managing state and performing side effects in functional components.
import { useState, useEffect } from "react"; 

// These components are used for styling and structuring content. 
import { Container, Table } from "react-bootstrap";

// This component appears to handle comments related to the team.
import CommentForm from "../components/CommentForm.js";

// t provides access to the current URL location.
import { useLocation } from "react-router-dom"; 



// This component displays information about the teams.
export default function TeamInfo() {
  
  // Uses the useLocation hook to access information about the current URL location.
  const location = useLocation(); 
  
  // Declares a state variable teamId using the useState hook. setTeamId is a function used to update the teamId state.
  const [teamId, setTeamId] = useState(); 
  
  // Declares a state variable teamInfo using the useState hook. setTeamInfo is a function used to update the teamInfo state.
  const [teamInfo, setTeamInfo] = useState() 




// This useEffect hook listens for changes in the location.search property and extracts the teamId query parameter from the URL. It updates the teamId state based on the extracted value.

  useEffect(() => {
    
    // extracts query string from params
    const searchParams = new URLSearchParams(location.search); 
    // extracts query strings params from url
    const queryParamValue = searchParams.get('teamId'); 
    console.log(queryParamValue)
    
    // updates teamId with the exact value
    setTeamId(queryParamValue) 
    
    // updates the value when the query string changes 
  }, [location])   

  
  // allows me to do side effects & Fetchs Team stats from an API or data source
  useEffect(() => {
    // if teamId is available fetch data from api using && 
    // fetching team info based on data
    teamId && fetch(`https://zbsports-api.ue.r.appspot.com/api/team/${teamId}`) 
    
    // called when then fetch is successful and inside the callback the response is paired with json
      .then(res => res.json()) 
    
      //  The parsed data is then used to update the teamInfo state using the setTeamInfo function. and it set retrived team info in stat
      .then(data => setTeamInfo(data)) 
      
      // this catch is used if theres an error fething the data
      .catch(err => console.error(err)); 
      
      // And this teamId in the useEffect hook make sure it only runs when the teamId changes
  }, [teamId]); 
 
  return (
      // team Logo:
      // An image tag is used to display the team logo.
      // The src attribute is used to set the teamInfo?.logo value, which is retreved from the teamInfo state
      // The alt attribute is used to set team logos for each team 

    // Team Name :
    // An H1 tag is used to display the team name
    // the content is to the teamInfo?.name value, retrieved from the teamInfo state

    // Team Stats Table:
    // A table from bootstrap is used to display the team stats
    // The table has a striped and bordered styles
    // Colunms for win/loss/draw , points, games played
    // Each cell uses conditional rendering to check if the corresponding data exists in the teamInfo state.
    // If the data exists, it is displayed inside a div element. if not it display nothing 


    <Container>
  
      <img src={teamInfo?.logo} alt="team logo" />
      <h1>{teamInfo?.name}</h1>
      <Table striped bordered >
        <thead>
          <tr>
            <th></th>
            <th>Wins</th>
            <th>Losses</th>
            <th>Draws</th>
            <th>Points</th>
            <th>Games </th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td>Home</td>
          <td><div>{teamInfo?.games.wins.home.total}</div></td>
          <td>20</td>
          <td>0</td>
          <td><div>{teamInfo?.points.for.total.home}</div></td>
          <td><div>{teamInfo?.games.played.home}</div></td>
        </tr>
        <tr>
        <td>Away</td>
          <td><div>{teamInfo?.games.wins.away.total}</div></td>
          <td>30</td>
          <td>0</td>
          <td><div>{teamInfo?.points.for.total.away}</div></td>
          <td><div>{teamInfo?.games.played.away}</div></td>
        </tr>
        <tr>
        <td>All</td>
          <td><div>{teamInfo?.games.wins.all.total}</div></td>
          <td>50</td>
          <td>0</td>
          <td><div>{teamInfo?.points.for.total.all}</div></td>
          <td><div>{teamInfo?.games.played.all}</div></td>
        </tr>
      </tbody>
      </Table>

      <CommentForm teamId={teamId}/>
    </Container>

  )
}

// CommentForm: 
// The CommentForm component is imported from another file and rendered within the TeamInfo component.
// The teamId state is passed as props to the CommentForm component, which allows it to retrieve and display comments specific to the current team